// import RepositoryFactory from "@/apis";
// const Subscribe = RepositoryFactory.subscribe;
// const Coupon = RepositoryFactory.coupon;
// const Features = RepositoryFactory.features;
import Subscribe from "../../apis/subscribe";
import Coupon from "../../apis/coupon";
import Features from "../../apis/planFeatures";

export default {
  CreateMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.create_membership(payload);
        // commit("CREATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  UpdateMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.update_membership(payload);
        // commit("UPDATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  GetMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.get_membership(payload);
        commit("GET_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetAllMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.get_all_membership(payload);
        commit("GET_ALL_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetMembershipForAdmin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.get_membership_for_admin(payload);
        // console.log({ data: data.data });
        commit("GET_MEMBERSHIP_FOR_ADMIN", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  DeleteMembership({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Subscribe.delete_membership(payload);
        // commit("DELETE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  /////////////////////////////////////////////////////////////////////
  /////////////////////////COUPON////////////////////////////////////
  /////////////////////////////////////////////////////////////////////
  GetCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Coupon.get_coupon(payload);
        commit("GET_COUPON", data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  CreateCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Coupon.create_coupon(payload);
        // commit("CREATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  UpdateCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Coupon.update_coupon(payload);
        // commit("UPDATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  DeleteCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Coupon.delete_coupon(payload);
        // commit("DELETE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  SubmitCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Coupon.submit_coupon(payload);
        // commit("DELETE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  /////////////////////////////////////////////////////////////////////
  /////////////////////////FEATURES/////////////////////////////////
  ////////////////////////////////////////////////////////////////////

  GetAllFeatures({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.getAllFeature(payload);
        commit("GET_FEATURE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  CreateFeatures({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.createFeature(payload);
        // commit("CREATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  UpdateFeatures({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.updateFeature(payload);
        // commit("UPDATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  DeleteFeatures({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.deleteFeature(payload);
        // commit("DELETE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.addCategory(payload);
        // commit("CREATE_MEMBERSHIP", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Features.getCategory(payload);
        commit("GET_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
